//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    props: {
        propValue: {
            type: Array,
            default: () => [],
        },
        element: {
            type: Object,
            default: () => {},
        },
    },
}
